<script setup lang="ts">
import { RouterView } from 'vue-router'
import Toast from 'primevue/toast'
</script>

<template>
  <RouterView />
  <Toast />
</template>

<style scoped>
.app {
  min-height: 100vh;
}
</style>
